export default __webpack_public_path__ + "static/media/facebook.200fe182.svg";